<template>
  <div>
    <TheHeader
      back-route="/opportunities"
      with-cross
      @close="goBack"
    />
    <BaseSection>
      <BaseTitleGroup
        :title="$t('Legal information')"
        subtitle="Kerala Ventures"
        class="mb-6"
      />
      <BaseParagraph
        ref="mainDiv"
        class="mb-32"
        v-html="$t('KYC introduction')"
      />
    </BaseSection>
    <TheBottomCheckbox
      ref="bottomCheckbox"
      :message="$t('KYC Checkbox')"
      :grey-theme="!scrolled"
      @click.native="goForward()"
    />
  </div>
</template>

<script>
import kyc from '@/mixins/kyc';
import { mapActions } from 'vuex';
import TheHeader from '../../components/TheHeader.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';
import TheBottomCheckbox from '../../components/TheBottomCheckbox.vue';

export default {

  name: 'KycIntroduction',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    TheBottomCheckbox,
  },
  mixins: [kyc],
  data() {
    return {
      scrolled: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.handleScroll();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    goBack() {
      this.$router.push('/opportunities');
    },
    handleScroll() {
      const windowBottom = window.scrollY + window.outerHeight;
      const { mainDiv, bottomCheckbox } = this.$refs;
      const visibleBottom = windowBottom - bottomCheckbox.$el.offsetHeight;
      const mainDivBottom = mainDiv.$el.offsetHeight + mainDiv.$el.offsetTop;
      if (visibleBottom > (mainDivBottom - 70)) {
        this.scrolled = true;
      }
    },
    goForward() {
      if (this.scrolled) {
        this.validateKycIntroduction();
        this.$router.push('/kyc/job');
      }
    },
    ...mapActions('kyc', ['validateKycIntroduction']),
  },
};
</script>
